import Label from "components/Label/label.component";
import Subtitle from "components/Subtitle/subtitle.component";
import dompurify from "dompurify";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GenericAlert from "../../../components/Alert/genericAlert.component";
import Button from "../../../components/Button/button.component";
import { DivEmail } from "../../../components/Card/card.style";
import Title from "../../../components/Title/title.component";
import { Creators as AudienciaActions } from "../../../store/ducks/alertas/audiencia";

class CadastroAudiencia extends Component {
	state = {
		loading: false
	};

	componentDidMount() {
		const { AudienciaActions: audienciaActions, alertaId } = this.props;
		this.setLoading(true);
		audienciaActions.audienciaBuscarPorAlertaId(
			alertaId,
			this.setLoading.bind(this)
		);
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;

		// eslint-disable-next-line react/no-danger
		return (
			<span
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	render() {
		const {
			audiencia: { crepdecs, mensagem, sms, alertaStatus },
			municipiosFromGeo: { municipios },
			onClick,
			handleBackButton,
			responsavel,
			dataAcao,
			responsavelEmissao,
			dataHoraEmissao
		} = this.props;
		return (
			<div className="mt-3">
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}
				{
					<GenericAlert
						type="primary"
						body={
							<div>
								<Subtitle style={{ color: "#134265" }}>
									Informações sobre o alerta
								</Subtitle>
								<div
									className="row"
									style={{ paddingTop: "15px" }}
								>
									<Label
										label="Status"
										text={
											((alertaStatus || {}).status || {})
												.nome || " ---"
										}
										col={4}
									/>

									<Label
										label={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? "Data/Hora da emissão"
												: "Data/Hora"
										}
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? dataHoraEmissao
												: dataAcao
										}
										col={4}
									/>

									<Label
										label="Responsável"
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? responsavelEmissao
												: responsavel
										}
										col={4}
									/>
								</div>
								{(((alertaStatus || {}).status || {}).nome ===
									"Cessado" ||
									((alertaStatus || {}).status || {}).nome ===
										"Cancelado") && (
									<div className="row">
										<Label
											label="Mensagem"
											text={this.innerHTMLPurified(
												(alertaStatus || {}).mensagem ||
													" ---"
											)}
										/>
									</div>
								)}
							</div>
						}
					/>
				}
				<Title>Audiência</Title>
				<hr />

				<div className="row mb-2">
					<Label
						label="Prefeituras"
						text={
							municipios.length > 0
								? municipios.map((item, index) => (
										<span key={item.id}>
											{item.nome}
											{index === municipios.length - 1
												? ""
												: ", "}
										</span>
								  ))
								: " --- "
						}
						col={12}
						colLabel={6}
					/>
				</div>

				<div className="row mb-2">
					<Label
						label="CREPDEC&#39;s"
						text={
							crepdecs.length > 0
								? crepdecs.map((item, index) => (
										<span key={item.id}>
											{item.nome}
											{index === crepdecs.length - 1
												? ""
												: ", "}
										</span>
								  ))
								: " --- "
						}
						col={12}
						colLabel={6}
					/>
				</div>

				<Subtitle>SMS</Subtitle>
				<hr />
				<div className="row mb-2">
					<Label
						label="SMS"
						text={sms || " --- "}
						col={12}
						colLabel={12}
					/>
				</div>
				<Subtitle>E-mail</Subtitle>
				<hr />
				<div className="col-md-12 pl-0">
					<span>
						<strong className="font-weight-bold">Assunto:</strong>{" "}
						Emissão de Alerta
					</span>
					<div className="col-12">
						<React.Fragment>
							<DivEmail>
								<span>
									<strong className="font-weight-bold">
										ESTADO DO RIO GRANDE DO SUL
									</strong>
									<br />
									<strong className="font-weight-bold">
										GOVERNADORIA DO ESTADO
									</strong>
									<br />
									<strong className="font-weight-bold">
										CASA MILITAR
									</strong>
									<br />
									<strong className="font-weight-bold">
										SUBCHEFIA DE PROTEÇÃO E DEFESA CIVIL
									</strong>
									<br />
								</span>
								<br />
								<br />
							</DivEmail>
							{this.innerHTMLPurified(mensagem)}
							<DivEmail>
								<br />
								<br />
								<span>Plantão CODEC</span>
								<br />
								<span>
									<strong className="font-weight-bold">
										{"'"}Defesa Civil somos todos nós.{"'"}
									</strong>
								</span>
								<br />
								<span>
									<u>Defesa Civil</u>
								</span>
								<br />{" "}
								<span>
									Rua Gal Andrade Neves, nº 106, 11º Andar -
									Centro - Porto Alegre
								</span>
								<br />
								<span>
									e-mail: defesa-civil@casamilitar.rs.gov.br
								</span>
								<br />
								<span>Fone: (51) 3221-7098</span>
								<br />
							</DivEmail>
						</React.Fragment>
					</div>
				</div>

				<Subtitle>Dados da emissão do alerta</Subtitle>
				<hr />

				<div className="row">
					<Label
						label="Data/Hora da emissão"
						text={dataHoraEmissao || "---"}
						col={6}
						colLabel={6}
					/>
					<Label
						label="Responsável"
						text={responsavelEmissao || "---"}
						col={6}
						colLabel={6}
					/>
				</div>
				<div className="row mt-3">
					<div className="col-md-6">
						<div className="float-left">
							<Button
								type="button"
								cancel
								text="Sair"
								icon="fas fa-times"
								onClick={() => handleBackButton()}
							/>
							<Button
								onClick={() => onClick("analise")}
								type="submit"
								primary
								text="Voltar"
								icon="fas fa-arrow-left"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	audiencia: state.audiencia.emissaoAlerta,
	municipiosFromGeo: state.audiencia.emissaoAlerta,
	responsavel: state.audiencia.responsavel,
	dataAcao: state.audiencia.dataAcao,
	responsavelEmissao: state.audiencia.responsavelEmissao,
	dataHoraEmissao: state.audiencia.dataHoraEmissao
});

const mapDispatchToProps = dispatch => ({
	AudienciaActions: bindActionCreators(AudienciaActions, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CadastroAudiencia);
